<template>
  <section v-show="sidebarCurrentPanel === 'themes'"  class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
    <div class="kp-modular-tab pt-page no-fade pt-page-current">
      <header class="kp-modular-title">{{ $t('general.labels.themes') }}</header>
      <div class="submenu-content sub-color">
        <theme-header></theme-header>
        <theme-list></theme-list>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import ThemeHeader from './Header.vue';
import ThemeList from './List.vue';

export default {
  components: {
    ThemeHeader,
    ThemeList,
  },
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
  }),
  mounted() {
    this.$store.dispatch('themeGetAll');
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?c85711be
 **/